"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const common_1 = require("@Const/common");
const Button_1 = require("@Components/Buttons/Button");
const react_1 = __importDefault(require("react"));
const UploadedDocumentsList = ({ uploadedFiles, filesWereUploaded, setUploadedFiles, browseFilePickerRef, }) => (react_1.default.createElement("ul", null, uploadedFiles.map((file, index) => (react_1.default.createElement("li", { key: index },
    react_1.default.createElement("img", { src: common_1.ICONS.documentIcon, alt: "file-icon" }),
    react_1.default.createElement("div", { className: 'file-preview-name-container' },
        react_1.default.createElement("b", null, file.name),
        react_1.default.createElement("div", null,
            Math.floor(file.size / 1000),
            " KB")),
    filesWereUploaded && react_1.default.createElement("img", { className: 'file-uploaded-check-icon', src: common_1.ICONS.check, alt: "check" }),
    !filesWereUploaded && (react_1.default.createElement(Button_1.Button, { className: 'remove-file-button', mainColor: true, type: 'tertiary', onClick: () => {
            if (browseFilePickerRef.current) {
                const modifiedFilesList = uploadedFiles.filter((f) => f !== file);
                setUploadedFiles(modifiedFilesList);
            }
        } }, "Remove")))))));
exports.default = UploadedDocumentsList;
